// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"500a2230","186":"1d54c17b","221":"6e39f4f2","508":"daae6494","952":"339fc768"}[chunkId] + ".chunk.js";
};